import { IBaseAction } from '../../../interfaces/IBaseAction'
export enum Keys {
    LOADCONTACTS = 'react/common/contacts/LOADCONTACTS',
    LOADCONTACTS_PENDING = 'react/common/contacts/LOADCONTACTS_PENDING',
    LOADCONTACTS_FULFILLED = 'react/common/contacts/LOADCONTACTS_FULFILLED',
    LOADCONTACTS_REJECTED = 'react/common/contacts/LOADCONTACTS_REJECTED',

    SAVECARDNUMBER = 'react/common/contacts/SAVECARDNUMBER',
    SAVEBLOCKACCESSDATE = 'react/common/contacts/SAVEBLOCKACCESSDATE',
    ADDBLOCKACCESSDATE = 'react/common/contacts/ADDBLOCKACCESSDATE',
    SAVEGREENPASS = 'react/common/contacts/SAVEGREENPASS',
    
    // SAVEGREENPASS_PENDING = 'react/common/contacts/SAVEGREENPASS_PENDING',
    // SAVEGREENPASS_FULFILLED = 'react/common/contacts/SAVEGREENPASS_FULFILLED',
    // SAVEGREENPASS_REJECTED = 'react/common/contacts/SAVEGREENPASS_REJECTED',
    
    LOADRECENTCONTACTS = 'react/common/contacts/LOADRECENTCONTACTS',
    LOADRECENTCONTACTS_PENDING = 'react/common/contacts/LOADRECENTCONTACTS_PENDING',
    LOADRECENTCONTACTS_FULFILLED = 'react/common/contacts/LOADRECENTCONTACTS_FULFILLED',
    LOADRECENTCONTACTS_REJECTED = 'react/common/contacts/LOADRECENTCONTACTS_REJECTED',

    LOADCONTACTSPAGINATED = 'react/common/contacts/LOADCONTACTSPAGINATED',
    LOADCONTACTSPAGINATED_PENDING = 'react/common/contacts/LOADCONTACTSPAGINATED_PENDING',
    LOADCONTACTSPAGINATED_FULFILLED = 'react/common/contacts/LOADCONTACTSPAGINATED_FULFILLED',
    LOADCONTACTSPAGINATED_REJECTED = 'react/common/contacts/LOADCONTACTSPAGINATED_REJECTED',

    LOADCONTACTRESERVATIONS = 'react/common/contacts/LOADCONTACTRESERVATIONS',
    LOADCONTACTRESERVATIONS_PENDING = 'react/common/contacts/LOADCONTACTRESERVATIONS_PENDING',
    LOADCONTACTRESERVATIONS_FULFILLED = 'react/common/contacts/LOADCONTACTRESERVATIONS_FULFILLED',
    LOADCONTACTRESERVATIONS_REJECTED = 'react/common/contacts/LOADCONTACTRESERVATIONS_REJECTED',

    ADDNEWUSER = 'react/common/contacts/ADDNEWUSER',
    ADDNEWUSER_PENDING = 'react/common/contacts/ADDNEWUSER_PENDING',
    ADDNEWUSER_FULFILLED = 'react/common/contacts/ADDNEWUSER_FULFILLED',
    ADDNEWUSER_REJECTED = 'react/common/contacts/ADDNEWUSER_REJECTED',

    LOADCONTACT = 'react/common/contacts/LOADCONTACT',
    LOADCONTACT_PENDING = 'react/common/contacts/LOADCONTACT_PENDING',
    LOADCONTACT_FULFILLED = 'react/common/contacts/LOADCONTACT_FULFILLED',
    LOADCONTACT_REJECTED = 'react/common/contacts/LOADCONTACT_REJECTED',

    USERCONNECTED = 'react/common/contacts/USERCONNECTED',
    USERDISCONNECTED = 'react/common/contacts/USERDISCONNECTED',
    CLEARSELECTION = 'react/common/contacts/CLEARSELECTION',
    PRINT = "react/common/contacts/PRINT",
    DOWNLOAD = "react/common/contacts/DOWNLOAD",

    ADDROOM = 'react/common/contact/ADDROOM',
    ADDROOM_PENDING = 'react/common/contact/ADDROOM_PENDING',
    ADDROOM_FULFILLED = 'react/common/contact/ADDROOM_FULFILLED',
    ADDROOM_REJECTED = 'react/common/contact/ADDROOM_REJECTED',

    DELETEROOM = 'react/common/contact/DELETEROOM',
    DELETEROOM_PENDING = 'react/common/contact/DELETEROOM_PENDING',
    DELETEROOM_FULFILLED = 'react/common/contact/DELETEROOM_FULFILLED',
    DELETEROOM_REJECTED = 'react/common/contact/DELETEROOM_REJECTED',

    UPDATEROOM = 'react/common/contact/UPDATEROOM',
    UPDATEROOM_PENDING = 'react/common/contact/UPDATEROOM_PENDING',
    UPDATEROOM_FULFILLED = 'react/common/contact/UPDATEROOM_FULFILLED',
    UPDATEROOM_REJECTED = 'react/common/contact/UPDATEROOM_REJECTED',

    OTHER_ACTION = 'react/common/contacts/__any_other_action__',
}

export type Types = IBaseAction<Keys>;